// import React from 'react';
// import './Loading.scss';

// const Loading = () => {
//   return (
//     <div className='loadings'>
//       <div className='loading-containers'>
//         <div className="lds-ellipsis">
//           <div></div><div></div><div></div><div></div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Loading;
import React from 'react';

// This component recreates the exact loading animation
// For a production app, you would define these animations in your tailwind.config.js

const Loading = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-white">
      <div className="flex items-center justify-center">
        <div className="relative inline-block w-20 h-20">
          {/* These animations recreate the original SCSS exactly */}
          <div className="absolute top-[33px] left-2 w-[13px] h-[13px] rounded-full bg-black"
            style={{ animation: 'lds-ellipsis1 0.6s cubic-bezier(0, 1, 1, 0) infinite' }}></div>

          <div className="absolute top-[33px] left-2 w-[13px] h-[13px] rounded-full bg-black"
            style={{ animation: 'lds-ellipsis2 0.6s cubic-bezier(0, 1, 1, 0) infinite' }}></div>

          <div className="absolute top-[33px] left-8 w-[13px] h-[13px] rounded-full bg-black"
            style={{ animation: 'lds-ellipsis2 0.6s cubic-bezier(0, 1, 1, 0) infinite' }}></div>

          <div className="absolute top-[33px] left-14 w-[13px] h-[13px] rounded-full bg-black"
            style={{ animation: 'lds-ellipsis3 0.6s cubic-bezier(0, 1, 1, 0) infinite' }}></div>

          {/* Keyframes for the animations */}
          <style jsx global>{`
            @keyframes lds-ellipsis1 {
              0% { transform: scale(0); }
              100% { transform: scale(1); }
            }
            
            @keyframes lds-ellipsis3 {
              0% { transform: scale(1); }
              100% { transform: scale(0); }
            }
            
            @keyframes lds-ellipsis2 {
              0% { transform: translate(0, 0); }
              100% { transform: translate(24px, 0); }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
};

export default Loading;